module.exports = __webpack_public_path__ + "img/img13.e17dd198.jpg";